import { atom } from "jotai";

export const graphDirectionAtom = atom<"TB" | "LR">("LR"); // Default direction: Left to Right
graphDirectionAtom.debugLabel = "graphDirectionAtom";
